import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TIndexType {
  id: number;
  name: string;
  code: string;
  description: string;
  valid: boolean;
}

export interface IIndexType extends TIndexType {}

const IndexType = Model((model: TIndexType): IIndexType => {
  const _value: TIndexType = Object.assign({}, model);
  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get description() {
      return _value.description;
    },
    set description(value) {
      _value.description = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get code() {
      return _value.code;
    },
    set code(value) {
      _value.code = value;
    }
  };

  return ValidatableObject<IIndexType>(_model);
});

export default IndexType;
